<template>
  <div id="app" class>
    <div id="detectLeave" v-if="!$isMobile()" class="leaveDetection"></div>
    <AppSpinner v-if="spinner" />
    <AppHeader />
    <main class="app-body">
      <TheStepper />
      <AppFlowTransition>
        <router-view />
      </AppFlowTransition>
    </main>
    <div class="d-block d-md-none">
      <AppHelpbox :data="$store.state.pageData.HelpBox" pos="text-center" />
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import AppHeader from '@/components/base/AppHeader';
  import AppHelpbox from '@/components/base/AppHelpbox';
  import TheStepper from '@/components/base/TheStepper';
  import AppSpinner from '@/components/base/AppSpinner';

  import AppFlowTransition from '@/components/base/AppFlowTransition';
  export default {
    components: {
      AppHeader,
      AppFlowTransition,
      AppSpinner,
      AppHelpbox,
      TheStepper,
    },
    computed: {
      ...mapState(['spinner']),
    },
  };
</script>
<style lang="scss" scoped>
  .app-body {
    margin: 40px 20px 152px;
    background-color: #fff;
    padding: 100px 60px;
    position: relative;
    @include media-breakpoint-down(sm) {
      margin: 40px 0px 100px;
      padding: 70px 0px;
    }
  }
</style>

<style lang="scss">
  @import '@/assets/bootstrap/bootstrap.scss';
  @import '@/assets/scss/main.scss';
</style>
